import { Box, Card  } from "@mui/material";
import { RichTextInput } from "ra-input-rich-text";
import * as React from "react";
import {
  TextField,
  EditProps,
  useEditController,
  Edit,
  SimpleForm,
  Labeled,
  DateInput,
  useRecordContext,
} from "react-admin";
import { validateFutureDate } from "../../../constants";

const EditInterviewTitle = () => {
  const record = useRecordContext();
  if (!record) return <>Editando entrevista</>;
  return (
    <>
      Postulante {record?.application?.applicant?.user?.fullName} - Oferta{" "}
      {record?.application?.offer?.title}
    </>
  );
};

export const EditInterview: React.FC<EditProps> = (props) => {
  return (
    <Edit {...props} mutationMode="pessimistic" title={<EditInterviewTitle />}>
      <SimpleForm>
        <Labeled>
          <TextField
            source="application.applicant.user.fullName"
            label="Postulante"
          />
        </Labeled>
        <Labeled>
          <TextField source="application.offer.title" label="Oferta" />
        </Labeled>
        <Labeled>
          <TextField source="interviewer.fullName" label="Entrevistador" />
        </Labeled>
        <Box sx={{ display: "inline-block", width: "100%" }}>
          <Card sx={{ p: 2, mt: 2 }} variant="outlined">
            <DateInput 
              source="interviewDate" 
              label="Fecha de entrevista"
              validate={validateFutureDate}
            />
            <RichTextInput source="comment" label="Notas" fullWidth />
          </Card>
        </Box>
      </SimpleForm>
    </Edit>
  );
};
